import once from 'lodash.once';
import VistaprintAnalyticsService from 'services/VistaprintAnalyticsService';

const {
  recordEvent,
} = VistaprintAnalyticsService;

export const firePageHit = once(() => recordEvent('Page', 'Hit'));

export const fireSearchBarTextEntered = once(() => recordEvent('SearchBar', 'TextEntered'));

export function fireSuggestedSearchPillClicked(pillId) {
  recordEvent('SuggestedSearchPill', 'Clicked', pillId);
}

export function fireSearchResultClicked(pfid) {
  recordEvent('SearchResult', 'Clicked', pfid);
}

export function fireSearchBarGoButtonClicked(pfid) {
  recordEvent('SearchBarGoButton', 'Clicked', pfid);
}

export function fireProductAndPricingAnchorClicked() {
  recordEvent('ProductAndPricingAnchor', 'Clicked');
}

export function fireProductAndPricingListProductClicked(pfid) {
  recordEvent('ProductAndPricingList', 'ProductClicked', pfid);
}

export function fireDesignerProfilesDesignerChanged(designerName) {
  recordEvent('DesignProfiles', 'DesignerChanged', designerName.split(' ').join('').toLowerCase());
}

export function fireCustomerQuotesRightArrowClicked() {
  recordEvent('CustomerQuotes', 'RightArrowClicked');
}

export function fireCustomerQuotesLeftArrowClicked() {
  recordEvent('CustomerQuotes', 'LeftArrowClicked');
}

export function fireBackToTopAnchorClicked() {
  recordEvent('BackToTopAnchor', 'Clicked');
}



// WEBPACK FOOTER //
// ./src/utils/AnalyticsUtil.js